<template>
  <div class="company-card-list-wrapper fullheight">
    <Row type="flex" justify="space-between" align="middle" class="padding-b-20" v-if="showCount">
      <i-col :xs="24" :sm="12">
        <p style="font-size:18px"> Total Tech Providers: <b>{{ totalData }}</b> </p>
      </i-col>
      <i-col :xs="24" :sm="12" class="shortlist-results text-right" v-if="getTechProvidersFilters && userType == 3">
        <p><span style="color:#b00101">Step 2/5</span> Shortlist max. 20 Tech Providers. </p>
        <div>
          <Tooltip placement="bottom" :disabled="!(totalData < 1 || totalData > 50)" max-width="200">
            <Button icon="ios-search" class="k-btn-1" @click="handleShortList" :disabled="totalData < 1 || totalData > 50">Shortlist20</Button>
            <div slot="content">
              <p>Activates when filter results are less 51</p>
            </div>
          </Tooltip>
        </div>
      </i-col>
    </Row>
    <div class="companies-card-list fullheight" v-if="totalData > 0">
      <Filters style="margin-bottom:5px" @changed="handleSelectedFilter"/>
      <Row :gutter="20">
        <i-col :xs="24" :sm="12" :md="12" :xl="8" v-for="(company, idx) in companies" :key="idx" style="margin-bottom:20px">
          <CompanyCard
            :company="company"
            :enableSelection="enableSelection"
            :marked="isMarked(company.id)"
            @select="handleOnSelect($event, company)"
            @reload="handleReload"/>
        </i-col>
      </Row>
      <Page v-if="totalData > 20" :total="totalData" class="text-center" :page-size="20" @on-change="handleOnPageChange" style="padding-bottom:50px"/>
    </div>
    <NoData v-else message="There are no listings matching your search" class="centered"/>
    <Spin size="large" fix v-if="isLoading"></Spin>
  </div>
</template>

<script>
import { fetchCompanies, fetchCompaniesByCategory } from '@/services/companies'
import { fetchBookmarks } from '@/services/bookmarks'
import { fetchCategoryBySlug, fetchFirstCategoryBySlug, fetchSecondCategoryBySlug } from '@/services/categories'
import { mapGetters, mapActions } from 'vuex'
import CompanyCard from './CompanyCard'
import NoData from '@/components/ui/NoData'
import Filters from '@/components/ui/Filters'

export default {
  components: {
    CompanyCard,
    NoData,
    Filters
  },

  props: {
    enableSelection: {
      type: Boolean,
      default: false
    },
    showCount: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      isLoading: false,
      totalData: 0,
      currentPage: 1,
      sortBy: 'latest',
      companies: [],
      selectedCompanies: [],
      markedCompanies: [],
      userType: localStorage.getItem('userType'),
      selectedCategoryId: null
    }
  },

  computed: {
    ...mapGetters(
      {
        getTechProvidersFilters: 'techProviders/getTechProvidersFilters'
      }
    )
  },

  async mounted () {
    this.isLoading = true
    if (this.$route.params && this.$route.params.cat && this.$route.name.startsWith('company-')) {
      if (this.$route.params.firstcat || this.$route.params.secondcat) {
        let routeCatId = null
        if (this.$route.params.secondcat) {
          routeCatId = await this.handleFetchSecondCategoryBySlug(this.$route.params.cat, this.$route.params.firstcat, this.$route.params.secondcat)
        } else if (this.$route.params.firstcat) {
          routeCatId = await this.handleFetchFirstCategoryBySlug(this.$route.params.cat, this.$route.params.firstcat)
        }

        this.getCompanies(routeCatId)
      } else {
        const routeParCatId = await this.handleFetchCategoryBySlug(this.$route.params.cat)
        this.getCompanies(routeParCatId)
      }
    } else {
      this.getCompanies()
    }
    if (localStorage.getItem('_id')) this.getBookmarks()
  },

  methods: {
    ...mapActions(
      {
        setFilteredTechProviders: 'techProviders/setFilteredTechProviders'
      }
    ),
    getBookmarks () {
      fetchBookmarks().then(res => {
        this.markedCompanies = res.data.results[0].tech_providers.map(a => a.id)
      }).catch(err => {
        console.log('Failed to fetch marked companies: ', err)
      })
    },

    getCompanies (catId) {
      this.isLoading = true
      this.companies = []
      if (catId) {
        this.selectedCategoryId = catId
        const query = `?page=${this.currentPage}&sort_by=${this.sortBy}`
        fetchCompaniesByCategory(this.selectedCategoryId, query).then(res => {
          this.$emit('total', res.data.length)
          this.totalData = res.data.count
          this.companies = res.data.results
          this.isLoading = false
        }).catch(err => {
          console.log('Failed to fetch companies by category: ', err)
          this.isLoading = false
        })
      } else {
        const query = this.parseQuery()
        fetchCompanies(query).then(res => {
          this.$emit('total', res.data.count)
          this.totalData = res.data.count
          if (res.data && res.data.results) {
            this.companies = res.data.results
            if (this.getTechProvidersFilters) this.setFilteredTechProviders(res.data.results)
          } else {
            this.companies = []
          }
          this.isLoading = false
        }).catch(err => {
          console.log('Failed to fetch companies: ', err)
          this.isLoading = false
        })
      }
    },

    handleReload () {
      this.getCompanies()
      this.getBookmarks()
    },

    handleOnPageChange (val) {
      this.currentPage = val
      this.getCompanies(this.selectedCategoryId)
    },

    handleOnSelect (val, company) {
      if (val) {
        if (this.selectedCompanies.length > 19) {
          this.$Message.error('You have exceeded the maximum no. of allowed appointments')
        } else {
          this.selectedCompanies.push(company)
        }
      } else {
        this.selectedCompanies = this.selectedCompanies.filter(com => com.id !== company.id)
      }
      this.$emit('selected', this.selectedCompanies)
    },

    handleShortList () {
      this.$router.push({
        name: 'shortlist-companies'
      })
    },

    isMarked (val) {
      return this.markedCompanies.includes(val)
    },

    parseQuery () {
      const query = `page=${this.currentPage}&sort_by=${this.sortBy}`
      if (this.getTechProvidersFilters) {
        return this.getTechProvidersFilters + '&' + query
      } else {
        return '?' + query
      }
    },

    handleSelectedFilter (val) {
      this.currentPage = 1
      this.sortBy = val.toLowerCase()
      this.getCompanies()
    },

    async handleFetchCategoryBySlug (slug) {
      return await fetchCategoryBySlug(slug).then(res => {
        return res.data.id
      }).catch(err => {
        console.log('Failed to fetch categories by slug: ', err)
      })
    },

    async handleFetchFirstCategoryBySlug (parentSlug, firstSlug) {
      return await fetchFirstCategoryBySlug(parentSlug, firstSlug).then(res => {
        return res.data.id
      }).catch(err => {
        console.log('Failed to fetch categories by slug: ', err)
      })
    },

    async handleFetchSecondCategoryBySlug (parentSlug, firstSlug, secondSlug) {
      return await fetchSecondCategoryBySlug(parentSlug, firstSlug, secondSlug).then(res => {
        return res.data.id
      }).catch(err => {
        console.log('Failed to fetch categories by slug: ', err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.companies-card-list {
  height: calc(100% - 50px);
  overflow-y: scroll;
  overflow: auto;
  overflow-x: hidden;
}
</style>
